import { render, staticRenderFns } from "./AtmosphereLayer.vue?vue&type=template&id=48d12f53&lang=pug"
import script from "./AtmosphereLayer.vue?vue&type=script&lang=ts"
export * from "./AtmosphereLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports